<template>
  <layout name="LayoutDefault">
    <div class="About">
      <!-- Page Content -->
      <div class="container contents">
        <!-- Page Features -->
        <div class="pt-0 pt-md-3">
          <div class="row">
            <div class="col-lg-12">
              <div class="col-lg-2 ml-auto p-0">
                <select class="form-control category-order">
                  <option
                    :value="`${baseUrl}category/${this.$route.params.categoryId}/newest`"
                  >
                    Newest First
                  </option>
                  <option
                    :value="`${baseUrl}category/${this.$route.params.categoryId}/oldest`"
                  >
                    Oldest First
                  </option>
                  <option
                    :value="`${baseUrl}category/${this.$route.params.categoryId}/az`"
                  >
                    A-Z
                  </option>
                  <option
                    :value="`${baseUrl}category/${this.$route.params.categoryId}/za`"
                  >
                    Z-A
                  </option>
                </select>
              </div>

              <div class="section-items">
                <pagination v-bind="pagination">
                  <div slot-scope="{ scope }">
                    <div class="row">
                      <div
                        v-for="(item, k) in scope"
                        :key="k"
                        class="col-lg-2 col-sm-6 col-6 mb-5"
                      >
                        <ProductCard :item="item" />
                      </div>
                    </div>
                  </div>
                </pagination>

                <div v-if="pagination.items.length < 1 && !loading">
                  কোন বই পাওয়া যায়নি
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /.container -->
    </div>
  </layout>
</template>

<script>
import Layout from "../layouts/Layout";
import Pagination from "vue-and-pagination";
import ProductCard from "./common/ProductCard.vue";

export default {
  data() {
    return {
      categoryName: "Loading...",
      loading: true,
      pagination: {
        items: [],
        limit: 12,
        controlsOnTop: false,
        controlsOnBottom: true,
        page: 1,
        sidePagesNumber: 2,
      },
    };
  },
  components: {
    Layout,
    Pagination,
    ProductCard,
  },
  methods: {
    getProducts() {
      fetch(
        this.APIURL +
          "products-resources/category/" +
          this.$route.params.categoryId +
          "/" +
          this.$route.params.order
      )
        .then((response) => response.json())
        .then((json) => {
          this.pagination.items = json.data;
          if (this.pagination.items.length > 0) {
            this.categoryName = json.data[0].category_name;
          }
          this.loading = false;
        });
    }
  },
  mounted() {
    this.getProducts();
  },
};
</script>
